import $ from 'jquery';
import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';

//use to check if auth request is already in loading
window.ajaxAuthRequestLoading = false;

class Authenticate {

    /**
     * Get access token - storage - user|public, request - public
     * 
     * @param {*} clientId 
     * @param {*} canUsePublicAuth 
     * @returns Promise
     */
    getAccessToken(clientId, canUsePublicAuth) {
        try {
            let ajaxAuthRequest = window.ajaxAuthRequest;
            
            if (ajaxAuthRequest) {
                // already has the auth request
                return ajaxAuthRequest;
            } else {
                // if there's no auth request. Then get it from storage or backend
                ajaxAuthRequest = new Promise((resolve, reject) => {
                    //enable checking status of the request
                    window.ajaxAuthRequestLoading = true;

                    //check user access token is available in the storage
                    let userDetails = new LocalStorage.UserDetails(clientId);
                    let accessTokenData = userDetails.getData();
                    if (accessTokenData) {
                        //resolve with user access token from the storage
                        let data = accessTokenData.data;
                        resolve({token_type: data.token_type, access_token: data.access_token, type: 'user'});
                    } else {
                        //if user access token is not avaiable check public access token can be used
                        if (canUsePublicAuth) {
                            //if user access token is not available and if public access token can be used,
                            //then check if public access token is available in the storage
                            let publicAuth = new LocalStorage.PublicAuth(clientId);
                            accessTokenData = publicAuth.getData();
                            let type = 'public';
                            if (accessTokenData) {
                                //resolve with the public access token from the storage
                                let data = accessTokenData.data;
                                resolve({token_type: data.token_type, access_token: data.access_token, type: type});
                            } else {                                
                                //if public access token is not available in the storage, then request public access token from backend
                                let requestData = {
                                    client_id: clientId,
                                };
                                this.send(application_settings.endPoints.publicAuth, 'GET', requestData)
                                .then(accessTokenData => {
                                    //add public access token to the storage            
                                    if (accessTokenData && accessTokenData.success) {
                                        publicAuth.setData(accessTokenData);
                                    }
                                    //resolve with the public access token from the request
                                    let data = accessTokenData.data;
                                    resolve({token_type: data.token_type, access_token: data.access_token, type: type});
                                })
                                .catch(error => {
                                    reject(error);
                                });
                            }
                        } else {
                            // cannot no user access token avaiable and cannot use public access token
                            reject('401');
                        }
                    }
                });
                
                window.ajaxAuthRequest = ajaxAuthRequest;
                return ajaxAuthRequest;
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get user access token from refresh Token
     * 
     * @param {*} clientId 
     * @param {*} refreshToken 
     * @returns Promise
     */
    async refreshUserAccessToken(clientId, refreshToken) {
        try {
            let ajaxAuthRefreshRequest = window.ajaxAuthRefreshRequest;

            if (ajaxAuthRefreshRequest) {
                return ajaxAuthRefreshRequest;
            } else {
                ajaxAuthRefreshRequest = new Promise((resolve, reject) => {
                    let requestData = {
                        client_id: clientId,
                        refresh_token: refreshToken,
                    };

                    this.send(application_settings.endPoints.userTokenRefresh, 'POST', requestData)
                            .then(accessTokenData => {
                                //add data to storage
                                if (accessTokenData && accessTokenData.success) {
                                    let userDetails = new LocalStorage.UserDetails(clientId);
                                    userDetails.setData({data: accessTokenData});
                                }

                                resolve(accessTokenData);
                            })
                            .catch(error => {
                                reject(error);
                            });
                });
                window.ajaxAuthRefreshRequest = ajaxAuthRefreshRequest;
                return ajaxAuthRefreshRequest;
            }

        } catch (error) {
            throw error;
        }
    }

    /**
     * Send Request
     * 
     * @param {*} url 
     * @param {*} method 
     * @param {*} data 
     * @returns Promise
     */
    send(url, method, data) {
        try {
            let that = this;
            return new Promise(function (resolve, reject) {
                that.fetch({
                    endPoint: url,
                    method: method,
                    data: data,
                    onSuccess: function (json, status) {
                        resolve(json);
                    },
                    onError: function (jqXHR, textStatus) {
                        reject({
                            jqXHR: jqXHR,
                            textStatus: textStatus
                        });
                    }
                });
            });
        } catch (error) {
            throw error;
        }
    }

    /**
     * Ajax Request
     * 
     * @param {*} config 
     */
    fetch(config) {
        $.ajax({
            url: config.endPoint,
            data: config.data,
            method: config.method,
            cache: true,
            beforeSend: (jqXHR, settings) => {
                if (typeof config.onBeforeSend === "function") {
                    config.onBeforeSend.call({source: "ajaxBeforeSend"}, jqXHR, settings);
                }
            },
        }).done((data, status) => {
            if (typeof config.onSuccess === "function") {
                config.onSuccess.call({source: "ajaxDone"}, data, status);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            if (typeof config.onError === "function") {
                config.onError.call({source: "ajaxFail"}, errorThrown, jqXHR, textStatus);
            }
        });

    }

}

export default Authenticate;